// latest

import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import LoginForm from "./LoginForm";
import ResetPasswordForm from "./ResetPasswordForm";
import { userPool } from "../cognito/UserPool";
import summerSun from "../assets/images/sun.png"
import summerCloudSet1 from "../assets/images/clouds.png"
import summerCloudSet2 from "../assets/images/clouds2.png"
import summerBirdSet1 from "../assets/images/birds.png"
import summerBirdSet2 from "../assets/images/birds.png"
import summerWaves from "../assets/images/waves.png"
import backgroundImageYellow from "../assets/images/backgroundImageYellow.png";
import { isMobile } from "react-device-detect";

function LoginPage() {
  const [formType, setFormType] = useState(
    () => localStorage.getItem("formType") || "login"
  );
  // const [isLoading, setIsLoading] = useState(true);
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    PlutonicuserID,
    loading,
    setLoading,
    userType,
    currentFormType,
    setCurrentFormType,
  } = useContext(AuthContext);

  // const [PlutonicuserID, setPlutonicuserID] = useState(() => localStorage.getItem('PlutonicuserID'));
  const navigate = useNavigate();

  useEffect(() => {
    const savedNickname = localStorage.getItem("currentNickname"); // Use consistent key
    const savedPlutonicuserID = localStorage.getItem("PlutonicuserID");

    // if (savedNickname && savedPlutonicuserID) {
    //   // console.log('[LoginPage] Restoring nickname and userID from localStorage:', savedNickname, savedPlutonicuserID);
    //   setCurrentNickname(savedNickname);
    //   // setPlutonicuserID(savedPlutonicuserID);
    //   navigate("/therapy-rooms"); // Redirect if authenticated
    //   return;
    // }

    if (savedNickname && savedPlutonicuserID && !loading) {
  navigate("/therapy-rooms");
}


    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
      cognitoUser.getSession((err, session) => {
        if (err || !session.isValid()) {
          // console.log('[LoginPage] Invalid session. Redirecting to login.');
          setCurrentFormType("login");
          setLoading(false);
          return;
        }

        cognitoUser.getUserAttributes((err, attributes) => {
          setLoading(false);
          if (err || !attributes) {
            // console.log('[LoginPage] Failed to fetch user attributes.');
            setCurrentFormType("login");
            return;
          }

          const nicknameAttr = attributes.find(
            (attr) =>
              attr.Name === "nickname" || attr.Name === "custom:nickname"
          );
          const userIDAttr = attributes.find(
            (attr) => attr.Name === "custom:PlutonicuserID"
          );

          const userNickname = nicknameAttr ? nicknameAttr.Value : "";
          const id = userIDAttr ? userIDAttr.Value : null;

          if (userNickname && id) {
            // console.log('[LoginPage] Session valid. Setting nickname and userID:', userNickname, id);
            setCurrentNickname(userNickname);
            // setPlutonicuserID(id);
            localStorage.setItem("currentNickname", userNickname);
            localStorage.setItem("PlutonicuserID", id);
            navigate("/therapy-rooms"); // Redirect after session validation
          }
        });
      });
    } else {
      setLoading(false);
    }
  }, [setCurrentNickname, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
  <div className="relative h-screen w-full flex flex-col items-center justify-start overflow-hidden bg-[linear-gradient(to_bottom,#61D8FF,#D7FFF6,#FFF9B8)]">

    {/* ☀️ Sun */}
<img
  src={summerSun}
  alt="sun"
  className="absolute top-[13vh] right-[1vw] w-[225px] md:w-[225px] pointer-events-none select-none z-0 animate-[spin_120s_linear_infinite]"
/>

    {/* ☁️ Clouds */}
<img
  src={summerCloudSet1}
  alt="clouds top left"
  className="absolute top-[12vh] left-[8vw] w-[480px] md:w-[460px] pointer-events-none select-none z-0"
/>

<img
  src={summerCloudSet2}
  alt="clouds middle"
  className="absolute top-[10vh] left-[44%] w-[400px] md:w-[480px] pointer-events-none select-none z-0"
/>

    {/* 🕊 Birds */}
<img
  src={summerBirdSet1}
  alt="birds left"
  className="absolute top-[38vh] left-[10vw] w-[140px] md:w-[180px] opacity-85 pointer-events-none select-none z-0"
/>

<img
  src={summerBirdSet2}
  alt="birds right"
  className="absolute top-[21vh] right-[17vw] w-[150px] md:w-[190px] opacity-85 pointer-events-none select-none z-0"
/>

    {/* 🌊 Waves footer */}
    <img
      src={summerWaves}
      alt="waves footer"
      className="absolute bottom-0 left-0 w-full h-[28vh] md:h-[32vh] object-cover pointer-events-none select-none z-0"
    />

    <Navbar
      currentNickname={currentNickname}
      handleLogout={handleLogout}
      setCurrentFormType={setCurrentFormType}
      showButtons={false}
      PlutonicuserID={PlutonicuserID}
    />

    <div className="relative flex flex-col items-center justify-center w-full h-full z-10">
      <div className="relative flex flex-col justify-center items-center w-[90%] max-w-[500px] h-[90%] max-h-[550px] sm:w-[80%] sm:h-[80%] md:w-[70%] md:h-[70%] p-4">

        <div
          className="relative text-center text-2xl font-bold text-black mb-6 lg:hidden"
          style={{ fontFamily: "Poppins-Semibold, Poppins, sans-serif" }}
        >
          Therapy Built for You
        </div>

        <div className="relative mt-4">
          {isMobile ? (
            <div className="text-center text-black text-lg font-medium px-4">
              Plutonic is not supported on mobile devices at this time.
            </div>
          ) : currentFormType === "login" ? (
            <LoginForm
              onLoginSuccess={(nickname, id) => {
                localStorage.setItem("currentNickname", nickname);
                localStorage.setItem("PlutonicuserID", id);
                navigate("/therapy-rooms");
              }}
            />
          ) : (
            <ResetPasswordForm />
          )}
        </div>
      </div>
    </div>
  </div>
);
}

export default LoginPage;
